import { gql } from "@apollo/client";

export const ARTICLE_MANY = gql`
  query Article_many($pagination: PaginationInput!) {
  article_many(pagination: $pagination) {
    nextPageCursor
    hasNextPage
    count
    data {
      _id
      title
      image
      body
      featured
      excerpt
      views
      createdAt
      updateAt
      id
    }
    
  }
}
`;

export const ARTICLE_ONE= gql`
query Article_one($articleOneId: ID!) {
  article_one(id: $articleOneId) {
    _id
    title
    image
    body
    featured
    excerpt
    views
    createdAt
    updateAt
    id
  }
}
`;


export const ARTICLE_POPULAR = gql`
query Article_popular($count: Int) {
  article_popular(count: $count) {
    _id
    title
    image
    body
    featured
    excerpt
    views
    createdAt
    updateAt
    id
  }
}
`;



export const RICK_N_MORTY_CHARACTER = gql`
query Characters($filter: FilterCharacter, $page: Int) {
  characters(filter: $filter, page: $page) {
    results {
      created
      gender
      id
      image
      name
      species
      status
      type
    }
  }
}
`;